// extracted by mini-css-extract-plugin
module.exports = {"first_container":"footer-module--first_container--1-ChF","logos_container":"footer-module--logos_container--3yuXi","imdb":"footer-module--imdb--3-mA9"};